<template>
    <svg :width="width" :height="height" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: 0 15px; background: none; shape-rendering: auto;" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="loader">
        <circle cx="50" cy="50" r="32" stroke-width="24" stroke="#32DAC3" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round">
            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
        </circle>
    </svg>
</template>

<script>
export default {
    name: "GiftIcon",

    props: {
        width: {
            type: Number,
            default: 20
        },

        height: {
            type: Number,
            default: 20
        },

        classes: {
            type: String
        }
    }
}
</script>
